// MODEL : instance of Column

define('app/editor/MetricView',['require','glu/itemView','hbs!./MetricView.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView');

	return ItemView.extend({

		template: require('hbs!./MetricView.hbs'),

		tagName: 'li',
		className: 'editColumnView',

		events: {
			'click .delete button': 'remove'
		},

		initialize: function() {},

		serializeData: function() {
			return this;
		},

		getName: function() {
			return this.model.getName();
		},

		getDescription: function() {
			return this.model.getDescription();
		},

		metricId: function() {
			return this.model.getId();
		},

		remove: function(e) {
			e.preventDefault();
			e.stopPropagation();

			var index = this.options.monitor.getMetrics().indexOf(this.model.getId());
			if (index > -1) {
				this.options.monitor.getMetrics().splice(index, 1);
			}
			this.options.monitor.trigger('monitor:change');
			this.appBus.trigger('monitor:refresh');
		},

		index: function() {
			return this.options.metrics.indexOf(this.model);
		}
	});
});

